module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modalcon"
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "mbox ex-modal",
    class: {
      'modal-height': _vm.exclusiveAdded,
      'prelative': !_vm.membershipManuallyAdded && !_vm.CHECK_PRODUCT_MATCHES && !_vm.CHECK_THREE_MONTHS_MEMBERSHIP && _vm.exclusiveAdded && _vm.step === 1
    }
  }, [_c('div', {
    staticClass: "modal-header prelative"
  }, [_c('img', {
    staticClass: "notify-logo ex-notify-logo",
    attrs: {
      "src": require("../../assets/images/membership-modal-logo.png"),
      "alt": "The Souled Store Logo"
    }
  }), _vm._v(" "), (!(!_vm.membershipManuallyAdded && !_vm.CHECK_PRODUCT_MATCHES && !_vm.CHECK_THREE_MONTHS_MEMBERSHIP && _vm.exclusiveAdded)) ? _c('span', {
    staticClass: " closebtn pointer",
    on: {
      "click": _vm.togglePopupClose
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.exclusiveAdded) ? _c('div', {
    staticClass: "modal-body mb0",
    class: _vm.membershipManuallyAdded ? 'modal-body-padding' : ''
  }, [_c('div', {
    staticClass: "text-center px10 congrats-text-wrapper"
  }, [_c('div', {
    staticClass: "notify-title dinline"
  }, [_vm._v("\n                  " + _vm._s(_vm.CHECK_THREE_MONTHS_MEMBERSHIP || _vm.isExclusiveRenewal ? _vm.EXC_POPUP_DATA && _vm.EXC_POPUP_DATA.congrats_text : '') + "\n                  " + _vm._s(!_vm.membershipManuallyAdded && !_vm.CHECK_PRODUCT_MATCHES && !_vm.CHECK_THREE_MONTHS_MEMBERSHIP && !_vm.isExclusiveRenewal ? _vm.EXC_POPUP_DATA && _vm.EXC_POPUP_DATA.congrats_text && _vm.EXC_POPUP_DATA.congrats_text.split('.')[0] : '') + "\n                ")]), _vm._v(" "), (_vm.exclusiveUser && _vm.CHECK_PRODUCT_MATCHES && !_vm.isExclusiveRenewal) ? _c('div', {
    staticClass: "notify-title dinline"
  }, [_vm._v("Congratulations! You have upgraded your plan to a 12 Month Membership.")]) : _vm._e(), _vm._v(" "), (!_vm.CHECK_THREE_MONTHS_MEMBERSHIP && _vm.calculations.exclusive_savings && !_vm.CHECK_PRODUCT_MATCHES && _vm.EXC_POPUP_DATA && _vm.EXC_POPUP_DATA.congrats_text && _vm.EXC_POPUP_DATA.congrats_text.split('.')[1]) ? _c('div', {
    staticClass: "exc-saving-modal-msg text-center modal-title"
  }, [_vm._v("\n                  " + _vm._s(_vm.EXC_POPUP_DATA.congrats_text.split('.')[1]) + "\n                ")]) : (_vm.showInitialExcPopupOnPdp && !_vm.membershipManuallyAdded && !_vm.CHECK_THREE_MONTHS_MEMBERSHIP && !_vm.CHECK_PRODUCT_MATCHES) ? _c('div', {
    staticClass: "exc-saving-modal-msg text-center modal-title"
  }, [_vm._v("\n                  You can "), _c('span', {
    staticStyle: {
      "color": "#1e9053",
      "font-weight": "bold"
    }
  }, [_vm._v("save " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.memberSavings || 0) + " ")]), _vm._v("on this product itself, with The Souled Store Membership.\n                ")]) : (!_vm.showInitialExcPopupOnPdp && !_vm.membershipManuallyAdded && !_vm.CHECK_THREE_MONTHS_MEMBERSHIP && _vm.calculations.exclusive_savings && !_vm.CHECK_PRODUCT_MATCHES || _vm.isExclusiveRenewal) ? _c('div', {
    staticClass: "exc-saving-modal-msg text-center modal-title"
  }, [_vm._v("\n                  you’re "), _c('span', {
    staticStyle: {
      "color": "#1e9053",
      "font-weight": "bold"
    }
  }, [_vm._v("SAVING " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.calculations.total_savings))]), _vm._v(" on this order itself.\n                ")]) : (_vm.calculations && _vm.calculations.exclusive_savings && _vm.membershipManuallyAdded) ? _c('div', {
    staticClass: "exc-saving-modal-msg text-center modal-title"
  }, [_vm._v("\n                  you’re "), _c('span', {
    staticStyle: {
      "color": "#1e9053",
      "font-weight": "bold"
    }
  }, [_vm._v("SAVING " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.calculations.total_savings))]), _vm._v(" on this order itself.\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.CHECK_ANNUAL_MEMBERSHIP || _vm.isExclusiveRenewal) ? _c('div', {
    staticClass: "just-rs"
  }, [_vm._v(_vm._s(_vm.EXC_POPUP_DATA && (_vm.EXC_POPUP_DATA.product_id === '147501' || _vm.isExclusiveRenewal) && _vm.EXC_POPUP_DATA.benefit_text || ("For just " + _vm.currencySymbol + " 199/ year you get.")))]) : _vm._e(), _vm._v(" "), (_vm.CHECK_THREE_MONTHS_MEMBERSHIP) ? _c('div', {
    staticClass: "just-three-months-rs"
  }, [_vm._v(_vm._s(_vm.EXC_POPUP_DATA && _vm.EXC_POPUP_DATA.benefit_text || 'For the next 3 months you now get:'))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container icons-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 popupImg big-discounts"
  }, [_c('img', {
    staticClass: "big-discount-img",
    attrs: {
      "data-src": _vm.imgBaseUrl + 'exclusive/icons-01.png',
      "width": "92",
      "alt": "Big Discounts"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "exclusive-benefits"
  }, [_c('p', {
    staticClass: "big-discount-txt"
  }, [_vm._v("Big Discounts ")]), _c('p', {
    staticClass: "all-product-txt"
  }, [_vm._v("On All Products. Everyday.")])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-12 delivery-special-launch-wrapper"
  }, [_c('div', {
    staticClass: "col-6 popupImg free-delivery"
  }, [_c('img', {
    staticClass: "free-delivery-img",
    attrs: {
      "data-src": _vm.imgBaseUrl + 'exclusive/icons-03.png',
      "width": "70",
      "alt": "Free Delivery"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "exclusive-benefits"
  }, [_vm._v("Free Delivery")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 popupImg"
  }, [_c('img', {
    staticClass: "early-access-img",
    attrs: {
      "data-src": _vm.imgBaseUrl + 'exclusive/icons-02.png',
      "width": "55",
      "alt": "Early Access"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "exclusive-benefits"
  }, [_vm._v("Early Access to Special Launches")])])])])]), _vm._v(" "), (_vm.exclusiveUser && _vm.CHECK_PRODUCT_MATCHES && !_vm.isExclusiveRenewal) ? _c('button', {
    staticClass: "btn btn-primary btn-block text-uppercase btn-continue pointer",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.togglePopup
    }
  }, [_vm._v("Confirm Upgrade")]) : _c('div', [(!_vm.membershipManuallyAdded && !_vm.CHECK_PRODUCT_MATCHES && !_vm.CHECK_THREE_MONTHS_MEMBERSHIP && _vm.EXC_POPUP_DATA) ? _c('button', {
    staticClass: "btn btn-primary btn-block btn-discounted-price pointer",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.discountedShop()
      }
    }
  }, [_vm._v(_vm._s(_vm.EXC_POPUP_DATA && _vm.EXC_POPUP_DATA.continue_button_text || 'Continue Shopping At Discounted Prices'))]) : _vm._e()]), _vm._v(" "), _c('div', [(!_vm.membershipManuallyAdded && !_vm.CHECK_PRODUCT_MATCHES && !_vm.CHECK_THREE_MONTHS_MEMBERSHIP && _vm.EXC_POPUP_DATA && _vm.EXC_POPUP_DATA.decline_button_text) ? _c('button', {
    staticClass: "btn btn-primary btn-block btn-no-full-price pointer",
    on: {
      "click": function($event) {
        _vm.removeExcFromCart(_vm.GET_MATCHED_PRODUCT_ID)
      }
    }
  }, [_vm._v(_vm._s(_vm.EXC_POPUP_DATA && _vm.EXC_POPUP_DATA.decline_button_text || 'Revert to your existing plan'))]) : _vm._e()])]) : _c('div', {
    staticClass: "modal-body mb0"
  }, [_c('div', {
    staticClass: "exc-desktop-header",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('p', {
    staticClass: "fbold bigDiscounts"
  }, [_vm._v("BIG DISCOUNTS"), _c('span', {
    staticClass: "fbold everyDayDeals"
  }, [_vm._v(" ON EVERY PRODUCT EVERY DAY")])])]), _vm._v(" "), _c('div', {
    staticClass: "exc-mobile-header"
  }, [_c('div', {
    staticClass: "fbold bigDiscounts"
  }, [_vm._v("BIG DISCOUNTS")]), _vm._v(" "), _c('div', {
    staticClass: "fbold everyDayDeals"
  }, [_vm._v("ON EVERY PRODUCT EVERY DAY")])]), _vm._v(" "), _c('p', {
    staticClass: "text-center dyk-text"
  }, [_vm._v("(Did you know? The average Member saves " + _vm._s(_vm.currencySymbol) + " 2600/year)")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "select-mem-header fsemibold text-center"
  }, [_vm._v("Select Your Membership")])]), _vm._v(" "), _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.dynamicExclusiveCards) ? _c('div', {
    staticClass: "col-12"
  }, [_c('mainExclusiveCards', {
    attrs: {
      "addExclusiveMem": _vm.addExclusive,
      "title_content": _vm.title_content,
      "popular_head": _vm.popular_head,
      "card_inactive": _vm.card_inactive,
      "card_active": _vm.card_active,
      "add_to_cart_btn": _vm.add_to_cart_btn,
      "togglePopup": _vm.togglePopup
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dynamicExclusiveCards) ? _c('div', {
    staticClass: "col-12"
  }, [_c('mainExcDynamicCardsVue', {
    attrs: {
      "addExclusiveMem": _vm.addExclusive,
      "title_content": _vm.title_content,
      "popular_head": _vm.popular_head,
      "card_inactive": _vm.card_inactive,
      "card_active": _vm.card_active,
      "add_to_cart_btn": _vm.add_to_cart_btn,
      "togglePopup": _vm.togglePopup
    }
  })], 1) : _vm._e()])])])])]), _vm._v(" "), (!_vm.membershipManuallyAdded && !_vm.CHECK_PRODUCT_MATCHES && !_vm.CHECK_THREE_MONTHS_MEMBERSHIP && _vm.exclusiveAdded && _vm.step === 1) ? _c('div', {
    staticClass: "exclusive-gif-wrapper pabsolute",
    attrs: {
      "id": "exclusive-gif-wrapper"
    }
  }, [(_vm.showGif) ? _c('img', {
    staticClass: "exclusive-gif",
    attrs: {
      "src": _vm.exclusiveGifToShow,
      "alt": "Exclusive Membership"
    }
  }) : _vm._e()]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa9c597e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ExclusiveModal.vue
// module id = 1101
// module chunks = 111